export default "__VITE_ASSET__CA3x2v1s__"